import React from 'react';
import { Cta } from './Cta';
import { Reveal } from './Reveal';
export function Hero() {
  const handleStartScore = () => {
    document.getElementById('quick-check-1')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="px-6 pt-16 pb-20 md:pt-28 md:pb-36 max-w-6xl mx-auto relative" data-id="element-126">
      <div className="grid md:grid-cols-2 gap-10 md:gap-16 items-center" data-id="element-127">
        <Reveal data-id="element-128">
          <div className="flex flex-col items-start" data-id="element-129">
            <span className="inline-block px-4 py-1.5 bg-white border border-gray-100 rounded-full text-xs font-semibold uppercase tracking-wider text-text-muted mb-7 shadow-sm" data-id="element-130">
              For expert-authors whose book is already in the world
            </span>

            <h1 className="text-[2.6rem] leading-[1.1] md:text-[3.5rem] md:leading-[1.08] lg:text-[4rem] lg:leading-[1.06] font-serif text-navy mb-8 tracking-[-0.01em] text-balance" data-id="element-131">
              <span className="block" data-id="element-132">Your book did what a book can do.</span>
              <span className="block text-seaglass italic" data-id="element-133">
                It created authority.
              </span>
              <span className="block" data-id="element-134">
                But did it lead to the opportunities you expected?
              </span>
            </h1>

            {/* Mobile-first CTA: visible early, before the long body */}
            <div className="md:hidden w-full mb-10" data-id="element-135">
              <Cta variant="primary" showArrow fullWidth onClick={handleStartScore} className="text-lg py-4 shadow-[0_10px_24px_-10px_rgba(212,165,116,0.7)]" data-id="element-136">
                Get Your Reader-to-Revenue Score
              </Cta>
              <p className="mt-3 text-sm text-text-muted font-medium text-center" data-id="element-137">
                8 questions. See what happens after someone reads your book.
              </p>
            </div>

            <div className="space-y-4 mb-10 text-lg text-text-muted leading-relaxed" data-id="element-138">
              <p data-id="element-139">
                You wrote the book. You launched it. People may have praised it,
                shared it, reviewed it, invited you on podcasts, or told you the
                ideas were exactly what they needed.
              </p>
              <p data-id="element-140">That matters. The book was not a failure.</p>
              <p className="text-navy font-semibold text-xl" data-id="element-141">
                But most readers still disappear.
              </p>
              <p data-id="element-142">
                You do not know who cared, what landed, what they needed next,
                or whether they were a fit for the work behind the book.
              </p>
            </div>

            <div className="border-l-2 border-seaglass pl-6 mb-10 w-full" data-id="element-143">
              <strong className="text-navy font-serif text-xl md:text-2xl leading-snug block" data-id="element-144">
                Author Leverage builds the path behind expert books, so serious
                readers have somewhere useful to go after the book creates
                trust.
              </strong>
            </div>

            {/* Desktop CTA */}
            <div className="hidden md:flex flex-row items-center gap-5" data-id="element-145">
              <Cta variant="primary" showArrow onClick={handleStartScore} className="text-lg px-9 py-4 shadow-[0_12px_28px_-10px_rgba(212,165,116,0.7)] hover:-translate-y-0.5" data-id="element-146">
                Get Your Reader-to-Revenue Score
              </Cta>
              <span className="text-sm text-text-muted font-medium max-w-[15rem]" data-id="element-147">
                8 questions. See what happens after someone reads your book.
              </span>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.2} data-id="element-148">
          <div className="relative w-full flex items-center justify-center" data-id="element-149">
            <img src="https://cdn.magicpatterns.com/uploads/eMFWNRfAqyFTdMNA6ZDpia/ChatGPT_Image_Apr_27,_2026,_02_44_47_PM.png" alt="An open book with a sea-glass path leading from its pages to a sand-gold doorway — the path from a book to real opportunities." className="w-full max-w-lg h-auto object-contain drop-shadow-[0_24px_40px_rgba(26,40,56,0.14)]" loading="eager" data-id="element-150" />
          </div>
        </Reveal>
      </div>
    </section>;
}